/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type EditCommentInput = {
    readonly commentID: string;
    readonly body: string;
    readonly clientMutationId: string;
};
export type EditCommentMutationVariables = {
    readonly input: EditCommentInput;
};
export type EditCommentMutationResponse = {
    readonly editComment: {
        readonly comment: {
            readonly body: string | null;
            readonly status: COMMENT_STATUS;
            readonly revision: {
                readonly id: string;
            } | null;
            readonly editing: {
                readonly edited: boolean;
            };
        };
        readonly clientMutationId: string;
    };
};
export type EditCommentMutation = {
    readonly response: EditCommentMutationResponse;
    readonly variables: EditCommentMutationVariables;
};



/*
mutation EditCommentMutation(
  $input: EditCommentInput!
) {
  editComment(input: $input) {
    comment {
      body
      status
      revision {
        id
      }
      editing {
        edited
      }
      id
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "EditCommentInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "body",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "revision",
        "storageKey": null,
        "args": null,
        "concreteType": "CommentRevision",
        "plural": false,
        "selections": [
            (v4 /*: any*/)
        ]
    } as any), v6 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "editing",
        "storageKey": null,
        "args": null,
        "concreteType": "EditInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "edited",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "EditCommentMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "editComment",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "EditCommentPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "comment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Comment",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/)
                            ]
                        },
                        (v7 /*: any*/)
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "EditCommentMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "editComment",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "EditCommentPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "comment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Comment",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v4 /*: any*/)
                            ]
                        },
                        (v7 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "EditCommentMutation",
            "id": "340a2877463a82879eabfd2b4ad0b364",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '66edfa2df18d97ecf92eeea5ca311769';
export default node;
